import styled from 'styled-components';
import React from 'react';
import { textH2 } from '@features/ui/styles/textStyles';

interface LayoutProps {
  children?: React.ReactNode,
}

const SectionTitle = ({ children } : LayoutProps) => (
  <SectionTitleWrapper>
    {children}
  </SectionTitleWrapper>
);

export default SectionTitle;

const SectionTitleWrapper = styled.h2`
  ${textH2}
  margin-bottom: 20px;
`;
